export default __webpack_public_path__ + "static/0183-e7dde647627898e6f0044ff246b6d8d4.png";